
import React from "react";

interface WalletBalanceProps {
  user: any;
  walletBalance: number | null;
  pricingModel: string;
}

export const WalletBalance: React.FC<WalletBalanceProps> = ({ 
  user, 
  walletBalance, 
  pricingModel 
}) => {
  if (!user || walletBalance === null || pricingModel === "free") {
    return null;
  }

  return (
    <div className="text-xs text-muted-foreground mt-2">
      Your wallet balance: ${walletBalance.toFixed(2)}
    </div>
  );
};
